import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export const ProblemSection: React.FC = () => {
  const {
    t
  } = useLanguage();
  const painPoints = [t('problem.point.1'), t('problem.point.2'), t('problem.point.3'), t('problem.point.4')];
  return <section className="py-24 bg-white" data-id="element-120">
      <div className="container mx-auto px-6 max-w-4xl" data-id="element-121">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} className="text-center mb-16" data-id="element-122">
          <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-123">
            {t('problem.title')}
          </h2>
          <p className="text-lg text-gray-600 font-sans max-w-2xl mx-auto" data-id="element-124">
            {t('problem.subtitle')}
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-125">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-beige-50 p-6 rounded-2xl flex items-start space-x-4 border border-beige-100" data-id="element-126">
              <div className="bg-coral-500/10 p-3 rounded-full flex-shrink-0 mt-1" data-id="element-127">
                <AlertCircle className="w-6 h-6 text-coral-500" data-id="element-128" />
              </div>
              <p className="text-lg font-sans text-dark font-medium pt-1" data-id="element-129">
                {point}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};